import { NgModule } from '@angular/core';

import { ApiService } from './services/api.service';
import { GlobalService } from './services/global.service';

import { authGuard } from './guards/auth.guard';
import { GoogleApiService } from './services/googleapi.service';
import { UnixTimeService } from './services/unixTime.service';

@NgModule({
  imports: [  ],
  providers: [
    ApiService,
    GlobalService,
    authGuard,
    GoogleApiService,
    UnixTimeService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/core.module.ts